import { RoundedButton } from '@codametrix/ui-components';
import React from 'react';

// RoundedButton forwards isLoading to Chakra at runtime but does not type it.
export const AtomButton = RoundedButton as React.FC<
  React.ButtonHTMLAttributes<HTMLButtonElement> & { isLoading?: boolean }
>;
